var _g, _pattern, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFordLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 120",
    enableBackground: "new 0 0 300 120",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M235.8,44.2L235.8,44.2C235.8,44.2,235.8,44.2,235.8,44.2C235.8,44.2,235.8,44.2,235.8,44.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M192.9,28.9c0,0.1,0.1,0.1,0.1,0.2C193,29,192.9,28.9,192.9,28.9z"
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "25%",
    style: {
      stopColor: "#cccccc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "75%",
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#FFFFFF"
    }
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    x: 0,
    y: 0,
    width: "10%",
    height: "300%",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "300%",
    fill: "url(#gradient)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "y",
    from: "-100%",
    to: "100%",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "300%",
    fill: "url(#gradient)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "y",
    from: "100%",
    to: "-100%",
    dur: "3s",
    repeatCount: "indefinite"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern)",
    d: "M151.1,107.3C76,107.3,15.1,86.2,15.1,60c0-26.1,60.9-47.3,135.9-47.3C226.2,12.7,287,33.9,287,60 C287,86.2,226.2,107.3,151.1,107.3z M151.1,16.8C78.6,16.8,19.9,36.2,19.9,60c0,23.9,58.7,43.2,131.2,43.2 c72.4,0,131.2-19.3,131.2-43.2C282.3,36.2,223.5,16.8,151.1,16.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern)",
    d: "M235.7,44.5c0.2-0.3,0-0.6-0.4-0.6c-2.2,0-5,0-7.3,0c-0.5,0-0.8,0.1-1.1,0.6c-0.8,1.6-11,16.8-12.9,19.8 c-0.3,0.5-0.7,0.4-0.8-0.1c-0.2-1.8-1.7-3.8-4.1-4.7c-1.8-0.7-3.6-0.9-5.5-0.6c-3.3,0.4-6.3,2.2-8.9,4.2c-4,3-7.4,6.9-11.8,9.8 c-2.4,1.6-5.7,2.9-7.9,0.9c-2-1.8-1.8-5.9,1.3-9.1c0.3-0.3,0.7-0.1,0.6,0.2c-0.3,1.4,0.1,2.9,1.2,3.9c1.3,1.2,3.2,1.3,4.9,0.5 c1.9-1,3.1-2.8,3.4-4.9c0.5-3.2-2-6.1-5.1-6.3c-2.5-0.2-5,0.7-7.3,2.7c-1.2,1-1.9,1.7-2.9,3.2c-0.2,0.4-0.6,0.4-0.6-0.1 c0.1-4.1-1.6-6.5-5-6.6c-2.7-0.1-5.5,1.4-7.7,3.1c-2.4,2-4.6,4.5-6.8,7c-0.3,0.3-0.5,0.3-0.6-0.3c-0.1-2.7-0.8-5.4-2-7.3 c-0.5-0.7-1.4-1-2.2-0.5c-0.4,0.2-1.6,0.8-2.6,1.5c-0.5,0.4-0.6,0.9-0.4,1.6c1.2,4.1,1,8.8-0.7,12.7c-1.5,3.6-4.5,6.9-8,8 c-2.3,0.7-4.7,0.4-6.2-1.7c-2-2.8-1.2-7.7,1.8-11.8c2.7-3.6,6.5-5.9,10.4-7.3c0.5-0.2,0.5-0.5,0.4-0.9c-0.2-0.6-0.5-1.5-0.7-1.9 c-0.4-0.9-1.3-1.1-2.6-1c-2.8,0.3-5.3,1.3-7.8,2.6c-6.5,3.5-9.8,10.3-11.3,13.9c-0.7,1.7-1.3,2.8-2,3.8c-1,1.3-2.3,2.5-4.7,4.6 c-0.2,0.2-0.4,0.6-0.2,1c0.2,0.5,1.5,2.2,1.8,2.4c0.4,0.2,0.8-0.1,1-0.2c1.7-1.1,3.6-2.9,4.6-4.1c0.3-0.4,0.7-0.2,0.9,0.4 c0.9,3.2,3.3,5.9,6.5,7c6,2,12.2-0.9,16.9-6c3-3.2,4.1-5.3,5.2-6.7c1.9-2.4,5.8-7.8,10.3-11.2c1.7-1.3,3.6-2.2,4.6-1.6 c0.8,0.5,1.1,1.7-0.2,4c-4.6,8.5-11.5,18.4-12.7,20.9c-0.2,0.4,0,0.7,0.4,0.7c2.4,0,4.8,0,7,0c0.4,0,0.5-0.2,0.7-0.4 c3.6-5.6,6.9-10.9,10.5-16.4c0.2-0.3,0.4-0.1,0.4,0.1c0.1,1.3,0.4,3,1.1,4.2c1.4,2.1,3.3,3,5.4,3c1.7,0,2.6-0.2,4.4-0.9 c1.5-0.6,2.7-1.3,3.6-1.9c0.5-0.4,0.6,0.3,0.6,0.3c-0.8,4.4,0.2,9.7,4.6,11.8c5.3,2.6,11.1-1.1,14.4-4.3c0.3-0.3,0.7-0.3,0.7,0.4 c0.1,1.3,0.6,2.8,1.7,3.8c2.8,2.8,8.4,1.7,14.1-2.7c3.6-2.8,7.4-6.8,10.8-10.9c0.1-0.2,0.2-0.4,0-0.7c-0.5-0.5-1.3-1.2-1.8-1.7 c-0.2-0.2-0.6-0.1-0.8,0c-3.5,3.3-6.7,7.2-11.2,10.3c-1.5,1.1-4,1.9-5.1,0.5c-0.4-0.6-0.4-1.4,0-2.4 C213.5,78.6,234.6,46.4,235.7,44.5z M207.8,71.5c0,0.2,0.4,0.5,0.7,0.6c0.1,0,0.2,0.1,0,0.4c-0.9,1.9-1.7,3-2.8,4.7 c-1,1.5-2.2,2.7-3.6,3.9c-2.1,1.8-5.1,3.7-7.5,2.4c-1.1-0.6-1.6-2.1-1.5-3.3c0.1-3.5,1.6-7,4.4-10.5c3.5-4.3,7.3-6.5,9.8-5.3 c2.6,1.2,1.8,4.2,0.6,6.6C207.8,71.2,207.8,71.3,207.8,71.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern)",
    d: "M82.7,89.8c-7.9,0.1-14.8-4.8-15.6-13.2c-0.4-4.7,0.9-8.8,3.5-12.2c2.3-3.1,6.3-5.6,9.7-6.2 c1.1-0.2,2.6-0.1,3.2,0.7c1,1.1,0.7,2.3-0.3,2.8c-2.6,1.3-5.6,3.5-7.2,6.6c-1.2,2.5-1.5,5.5,0.4,8.4c3.2,4.8,12,4.9,20.2-2.7 c2-1.9,3.8-3.7,5.7-5.8c3.6-4.1,4.8-5.6,9.6-12.3c0.1-0.1,0.1-0.2,0-0.2c0-0.1-0.1-0.1-0.2-0.1c-3.2,0.1-6,1-8.7,3.1 c-0.8,0.6-1.9,0.5-2.4-0.3c-0.5-0.8-0.2-2,0.7-2.6c4.4-3,9.1-3.6,14-4.4c0,0,0.3,0,0.6-0.4c2-2.6,3.5-4.9,5.6-7.5 c2.1-2.6,4.9-5,7-6.9c3-2.5,4.9-3.4,6.8-4.4c0.5-0.3-0.1-0.6-0.2-0.6c-10.8-2-21.9-4.6-32.6-0.7c-7.4,2.8-10.6,8.6-9.1,12.6 c1.1,2.8,4.8,3.2,8.2,1.6c2.8-1.4,5.5-3.6,7.3-6.5c1-1.6,3.2-0.4,2.1,2.3c-3.1,7.3-9.1,13.2-16.4,13.4c-6.2,0.2-10.2-4.4-10.2-10 c0-11.1,12.4-18.4,25.3-19.5c15.6-1.3,30.4,2.9,45.9,4.8c11.9,1.4,23.3,1.5,35.2-1.3c1.4-0.3,2.4,0.6,2.3,2c-0.1,2.1-1.7,4-5.6,6.2 c-4.5,2.5-9.2,3.2-14,3.2c-11.8,0.1-22.8-4.5-34.2-7c0,0.5,0.1,1.1-0.3,1.4c-6.3,4.7-12,9.4-15.8,16c-0.1,0.2-0.1,0.3,0.2,0.3 c3.3-0.2,6.3-0.3,9.4-0.5c0.5,0,0.6-0.2,0.5-0.6c-0.3-2.3,0.4-4.9,2.4-6.7c2.1-1.8,4.6-2.1,6.3-0.7c1.9,1.5,1.8,4.2,0.7,6.3 c-1.1,2.1-2.9,3.2-4.6,3.7c0,0-0.4,0.1-0.3,0.4c0.1,0.5,2.4,1.8,2.6,2.2c0.2,0.3,0.1,0.8-0.3,1.2c-0.2,0.3-0.6,0.5-1.1,0.5 c-0.4,0-0.6-0.1-1.2-0.4c-1-0.6-2.4-1.5-3.2-2.6c-0.3-0.4-0.5-0.4-1.2-0.3c-3.3,0.2-8.6,0.7-12.1,1.1c-0.9,0.1-1,0.3-1.2,0.6 c-5.6,9.3-11.7,19.3-18.3,26.1C94.8,87.8,88.9,89.7,82.7,89.8z M136.5,48.4c0.1,0.5,0.3,0.6,0.5,0.5c1.1-0.2,2.3-1.1,2.9-2.1 c0.6-0.9,0.9-2.3,0.3-2.8c-0.6-0.5-1.5-0.3-2.2,0.3C136.7,45.5,136.3,47.2,136.5,48.4L136.5,48.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFordLoader);
export default __webpack_public_path__ + "static/media/ford-loader.0c13c656c78bbdb70ff8c4f24993961f.svg";
export { ForwardRef as ReactComponent };